import firebase from "firebase";

export const formatTimestampDate = (timestamp: firebase.firestore.Timestamp) =>
    timestamp.toDate().toLocaleDateString("de-CH");

export const formatTimestampTime = (timestamp: firebase.firestore.Timestamp) =>
    timestamp.toDate().toLocaleTimeString("de-CH");
